export default "__VITE_ASSET__BTdKLeFD__"